import type { FetchCollectionsAllQuery } from "@src/generated-2026-07";
import type { FetchProductTagsQuery } from "@src/generated";
import { fromGqlId } from "@src/api/formatters/shopify";

export interface EntityOption {
  label: string;
  value: string;
}

export const collectionOptions = (
  data: FetchCollectionsAllQuery | undefined
): EntityOption[] =>
  (data?.collections?.edges ?? []).map((edge) => ({
    label: edge.node.title,
    value: fromGqlId(edge.node.id),
  }));

export const tagOptions = (
  data: FetchProductTagsQuery | undefined
): EntityOption[] =>
  (data?.productTags?.edges ?? []).map((edge) => ({
    label: edge.node,
    value: edge.node,
  }));
